import { render } from "./PatientsHeaderDoctorsFilter.vue?vue&type=template&id=6d3eb409&scoped=true"
import script from "./PatientsHeaderDoctorsFilter.vue?vue&type=script&lang=js"
export * from "./PatientsHeaderDoctorsFilter.vue?vue&type=script&lang=js"

import "./PatientsHeaderDoctorsFilter.vue?vue&type=style&index=0&id=6d3eb409&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3eb409"]])

export default __exports__